/* HeyBear · Header: scroll state, mobile menu, Shop mega menu, cart button. */
HB.section('header', function (root) {
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var nav = $('#nav'), off = [];
  var on = function (t, ev, fn, o) { t.addEventListener(ev, fn, o); off.push(function () { t.removeEventListener(ev, fn, o); }); };

  /* sticky header morph */
  var onScroll = function () { nav.classList.toggle('scrolled', scrollY > 40); };
  on(window, 'scroll', onScroll, { passive: true }); onScroll();

  /* Build enough identical announcement groups to cover the viewport plus one
     complete cycle. Advancing by one measured group makes the reset seamless. */
  (function () {
    var announce = $('.announce');
    var track = announce && announce.querySelector('.run');
    var source = track && track.querySelector('.announce-group');
    if (!announce || !track || !source) return;
    var frame = 0;
    var rebuild = function () {
      frame = 0;
      announce.classList.remove('is-ready');
      [].slice.call(track.querySelectorAll('.announce-group:not(:first-child)')).forEach(function (group) {
        group.remove();
      });
      var groupWidth = source.getBoundingClientRect().width;
      if (!groupWidth) return;
      var copies = Math.max(2, Math.ceil((announce.clientWidth + groupWidth) / groupWidth));
      for (var i = 1; i < copies; i += 1) {
        var clone = source.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (node) {
          node.removeAttribute('data-shopify-editor-block');
          if ((node.id || '').indexOf('shopify-block-') === 0) node.removeAttribute('id');
        });
        track.appendChild(clone);
      }
      track.style.setProperty('--announce-shift', groupWidth + 'px');
      void track.offsetWidth;
      announce.classList.add('is-ready');
    };
    var schedule = function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(rebuild);
    };
    schedule();
    on(window, 'resize', schedule, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    var observer = null;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      observer.observe(announce);
      observer.observe(source);
    }
    off.push(function () {
      if (frame) cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
    });
  })();

  /* Logo and Home always mean the true start of the homepage. Flag cross-page
     navigation so the homepage does not restore an earlier scroll position. */
  (function () {
    var forceTopKey = 'hb:home-force-top';
    var rootPath;
    try { rootPath = new URL(HB.routes.root || '/', location.origin).pathname; } catch (_) { rootPath = '/'; }
    $$('a[href]').forEach(function (a) {
      var url;
      try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin || url.pathname !== rootPath || url.search || url.hash) return;
      on(a, 'click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        try {
          sessionStorage.setItem(forceTopKey, '1');
          sessionStorage.removeItem('hb:home-history-restore');
          sessionStorage.removeItem('hb:home-history-curtain');
          sessionStorage.removeItem('hb:home-history-active');
        } catch (_) {}
        if (location.pathname !== rootPath) {
          e.preventDefault();
          try {
            var target = new URL(HB.routes.root || '/', location.origin);
            target.searchParams.set('hb-home', '1');
            target.hash = 'hb-home-top';
            location.assign(target.href);
          } catch (_) {
            location.href = (HB.routes.root || '/') + '?hb-home=1#hb-home-top';
          }
          return;
        }
        e.preventDefault();
        if (window.HB_GO_HOME_TOP) window.HB_GO_HOME_TOP();
        else {
          if (location.hash) history.replaceState(history.state, '', location.pathname + location.search);
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          window.scrollTo(0, 0);
        }
        if (window.ScrollTrigger) ScrollTrigger.update();
        try { sessionStorage.removeItem(forceTopKey); } catch (_) {}
      });
    });
  })();

  /* cart button opens the side cart */
  var cartBtn = $('#cartBtn');
  on(cartBtn, 'click', function () { HB.cart.open(); });
  on(document, 'hb:cart:updated', function (e) { var c = $('#cartCount'); if (c && e.detail) c.textContent = e.detail.item_count; });

  /* mobile menu */
  (function () {
    var b = $('#burger'), m = $('#mnav'); if (!b || !m) return;
    var set = function (o) {
      m.classList.toggle('open', o);
      if (o) setTimeout(function () { var x = $('#mnavX'); x && x.focus({ preventScroll: true }); }, 300);
      b.setAttribute('aria-expanded', o); b.setAttribute('aria-label', o ? 'Close menu' : 'Open menu');
      m.setAttribute('aria-hidden', !o); HB.lock(o); nav.classList.toggle('menu-open', o);
    };
    on(b, 'click', function () { set(!m.classList.contains('open')); });
    on($('#mnavX'), 'click', function () { set(false); b.focus(); });
    $$('#mnav a').forEach(function (a) { on(a, 'click', function () { set(false); }); });
    on(window, 'keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('open')) { set(false); b.focus(); } });
    on(window, 'resize', function () { if (innerWidth > 860 && m.classList.contains('open')) set(false); });
    on(cartBtn, 'click', function () { if (m.classList.contains('open')) set(false); });
  })();

  /* Shop mega menu: hover intent + preselect the chosen pack in the Shop section */
  (function () {
    var hm = $('.has-mega'), tr = $('.mm-trigger'), mega = $('.mega'); if (!hm || !tr || !mega) return;
    /* Keep the desktop menu in lockstep with the same Shopify product data used
       by the footer. This removes duplicated titles/prices and reflects live
       product availability without changing the approved menu composition. */
    var data = HB.data();
    var flavours = (data.flavours || []).filter(function (flavour) { return flavour && flavour.name; });
    var mix = data.mix || {};
    var variantHref = function (id) {
      var base = mix.url || '#shop';
      return id ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id : base;
    };
    var packUnits = function (variant) {
      if (variant.units > 1) return variant.units;
      if (/big|12/i.test(variant.title || '')) return 12;
      if (/cub|4/i.test(variant.title || '')) return 4;
      return 0;
    };
    var updatePack = function (key, test) {
      var card = mega.querySelector('[data-mm-pack="' + key + '"]');
      var variant = (mix.variants || []).find(test); if (!card) return;
      var title = card.querySelector('.mm-ft b');
      var detail = card.querySelector('.mm-ft small');
      var status = card.querySelector('.mm-ft em');
      if (!variant) {
        card.hidden = true;
        return;
      }
      card.hidden = false;
      var units = packUnits(variant);
      card.href = variantHref(variant.id);
      card.classList.toggle('is-sold-out', variant.available !== true);
      if (title) title.textContent = variant.title;
      if (detail) detail.textContent = units ? units + ' × 102g mixed bags' : 'Mixed flavour pack';
      if (status) status.textContent = variant.available === true && variant.price != null ? HB.money(variant.price) : 'Sold out';
    };
    var renderCatalogue = function () {
      updatePack('big', function (variant) { return /big|12/i.test(variant.title || '') || packUnits(variant) === 12; });
      updatePack('cub', function (variant) { return /cub|4/i.test(variant.title || '') || packUnits(variant) === 4; });
      var mixColumn = mega.querySelector('.mm-mix');
      if (mixColumn) mixColumn.hidden = !(mix.url && (mix.variants || []).length);
      $$('.mm-flav[data-f]').forEach(function (card) {
        var key = card.getAttribute('data-f');
        var flavour = flavours.find(function (item) { return item.key === key; });
        card.hidden = !flavour;
        if (!flavour) return;
        var image = card.querySelector('.mm-pack');
        var title = card.querySelector('b');
        var status = card.querySelector('small');
        var purchasable = (flavour.variants || []).some(function (variant) {
          return variant && variant.id && variant.available === true && variant.price != null;
        });
        card.href = flavour.url;
        card.classList.toggle('is-sold-out', !purchasable);
        if (image && flavour.pack) image.src = flavour.pack;
        if (title) title.textContent = flavour.name;
        if (status) status.textContent = purchasable ? 'Choose your pack' : 'Sold out';
      });
    };
    renderCatalogue();

    /* Reconcile the menu with the live product library after the immediate
       Liquid render. Shared request promises prevent duplicate endpoint work
       when the Shop section is mounted on the same page. */
    var catalogueRequests = HB.catalogueRequests = HB.catalogueRequests || {};
    var jsonUrl = function (product) {
      if (!product || !product.url) return '';
      try {
        var parsed = new URL(product && product.url, location.href);
        parsed.pathname = parsed.pathname.replace(/\/$/, '') + '.js';
        parsed.search = '';
        parsed.hash = '';
        return parsed.href;
      } catch (_) { return ''; }
    };
    var requestProduct = function (product) {
      var url = jsonUrl(product); if (!url) return Promise.resolve(null);
      if (!catalogueRequests[url]) {
        catalogueRequests[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
          if (response.status === 404) return { unavailable: true };
          if (!response.ok) return null;
          return response.json();
        }).catch(function () { return null; });
      }
      return catalogueRequests[url];
    };
    var mergeLive = function (product, live) {
      if (!product || !live) return;
      var existing = product.variants || [];
      if (live.unavailable) {
        existing.forEach(function (variant) { variant.available = false; });
        product.available = false;
        return;
      }
      if (!live.variants) return;
      product.variants = live.variants.map(function (variant, index) {
        var prior = existing.filter(function (item) {
          return String(item.id) === String(variant.id) || (item.sku && variant.sku && item.sku === variant.sku);
        })[0] || {};
        return Object.assign({}, prior, {
          id: variant.id,
          title: variant.title,
          sku: variant.sku || prior.sku,
          price: variant.price,
          compare: variant.compare_at_price,
          available: variant.available === true,
          order: prior.order || index + 1,
          plans: prior.plans || []
        });
      });
      product.handle = live.handle || product.handle;
      product.available = product.variants.some(function (variant) { return variant.available === true; });
      product.demo = false;
    };
    mega.setAttribute('aria-busy', 'true');
    Promise.all([mix].concat(flavours).map(function (product) {
      return requestProduct(product).then(function (live) { mergeLive(product, live); });
    })).then(function () {
      if (!mega.isConnected) return;
      renderCatalogue();
      document.dispatchEvent(new CustomEvent('hb:catalog:updated', { detail: data }));
    }).finally(function () {
      if (mega.isConnected) mega.removeAttribute('aria-busy');
    });
    var closeT;
    var open = function () { clearTimeout(closeT); hm.classList.add('open'); tr.setAttribute('aria-expanded', 'true'); };
    var close = function (now) { clearTimeout(closeT); closeT = setTimeout(function () { hm.classList.remove('open'); tr.setAttribute('aria-expanded', 'false'); }, now ? 0 : 280); };
    on(tr, 'pointerenter', open);
    on(mega, 'pointerenter', open);
    on(hm, 'pointerleave', function () { close(); });
    on(hm, 'focusin', open);
    on(hm, 'focusout', function (e) { if (!hm.contains(e.relatedTarget)) close(true); });
    on(hm, 'keydown', function (e) { if (e.key === 'Escape') { close(true); tr.focus({ preventScroll: true }); } });
    $$('.nav-mid > li:not(.has-mega), .nav > .wrap > .logo, .nav-right > *').forEach(function (item) {
      on(item, 'pointerenter', function () { close(true); });
    });
    $$('.mega [data-go]').forEach(function (a) {
      on(a, 'click', function (e) {
        var g = a.getAttribute('data-go');
        close(true);
        if (g === 'flav') return; /* opens the flavour product page */
        var shop = document.getElementById('shop');
        if (shop) {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('hb:shop:select', { detail: { go: g } }));
          shop.scrollIntoView({ behavior: HB.reduce ? 'auto' : 'smooth' });
        } else {
          e.preventDefault();
          location.href = HB.routes.root + '?hb-go=' + encodeURIComponent(g) + '#shop';
        }
        document.activeElement && document.activeElement.blur();
      });
    });
    $$('.mega a').forEach(function (a) { on(a, 'click', function () { close(true); }); });
  })();

  return function () { off.forEach(function (f) { f(); }); };
});
